/**
 * 售后管理 Saga集合
 */
import suggestions from './suggestions/model';
import deliveryeval from './deliveryeval/model';
import deliveryticket from './deliveryticket/model';
import deliverycomplain from './deliverycomplain/model';
export default [
    ...Object.values(suggestions.sagas), // 意见反馈
    ...Object.values(deliveryeval.sagas), // 评价管理
    ...Object.values(deliveryticket.sagas), // 罚单列表
    ...Object.values(deliverycomplain.sagas), // 配送投诉
];
